import Checkbox from '@mui/material/Checkbox';
import { Tooltip } from '@mui/material';
import RowActions from '@components/row-actions/row-actions.tsx';
import AppImage from '@components/app-image/app-image.tsx';

export const episodeColumns = (
  handleEdit: (id: string) => void,
  handleDelete: (id: string) => void,
  handleSelectRow: (rowId: string) => void,
  handleSelectAll: () => void,
  selectedRows: string[],
  tableData: any[],
  language: string
) => [
  {
    id: 'select',
    label: (
      <Checkbox
        className="primary-checkbox"
        checked={
          tableData?.length > 0 && selectedRows?.length === tableData?.length
        }
        indeterminate={
          selectedRows?.length > 0 && selectedRows?.length < tableData?.length
        }
        onChange={handleSelectAll}
      />
    ),

    field: 'select',
    render: (value: any, row: any) => (
      <Checkbox
        className="primary-checkbox"
        checked={selectedRows.includes(row._id)}
        onChange={() => handleSelectRow(row._id)}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  },
  {
    id: 'title',
    label: 'Title',
    field: 'title',
    render: (value: any) => (
      <Tooltip title={value?.[language]} followCursor>
        <span>{value?.[language] || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: true
  },
  {
    id: 'image',
    label: 'Image',
    field: 'image',
    render: (value: any) => (
      <div
        className={`h-13 w-13 rounded-md border border-(--gray-7) overflow-hidden cursor-pointer`}
      >
        <AppImage imgClassName="!h-full" filePath={value ?? undefined} />
      </div>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'description',
    label: 'Description',
    field: 'description',
    render: (value: any) => (
      <Tooltip title={value?.[language]} followCursor>
        <span>{value?.[language] || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: true
  },
  {
    id: 'Action',
    label: 'Actions',
    field: 'actions',
    render: (value: any, row: any) => (
      <RowActions<any>
        row={row}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
